<template>
  <div class="gx-login">
    <stars-canvas :count="80" :meteor-max="2" :meteor-gap="700" fixed />
    <float-pts :count="12" fixed />
<!--    <div class="gx-login__orb gx-login__orb&#45;&#45;1"></div>
    <div class="gx-login__orb gx-login__orb&#45;&#45;2"></div>-->

    <button class="gx-login__back" @click="goBack">
      <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
        <path d="M8 1.5L3 6.5l5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      返回首页
    </button>

    <!-- ── 左侧品牌区 ── -->
    <div class="gx-login__left">
      <div class="gx-login__brand">
<!--        <div class="gx-login__tree">🌳</div>-->
        <img src="https://xinghaohuo.oss-cn-beijing.aliyuncs.com/logo.png" style="width: 100px;height: 100px">
        <div class="gx-login__name">观星树</div>
        <div class="gx-login__slogan">AI智能店群运营</div>
        <div class="gx-login__sub">致力店群无人化</div>
        <div class="gx-login__divider"></div>
        <div class="gx-login__stats">
          <div v-for="s in stats" :key="s.l" class="gx-login__stat">
            <div class="gx-login__stat-v">{{ s.v }}</div>
            <div class="gx-login__stat-l">{{ s.l }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- ── 右侧表单区 ── -->
    <div class="gx-login__right">
      <div class="gx-login__panel">
        <div class="gx-login__head">
          <div class="gx-login__head-icon">✨</div>
          <h2 class="gx-login__title">{{ wxMode ? '扫码登录' : '欢迎回来' }}</h2>
          <p class="gx-login__en">{{ wxMode ? 'WECHAT LOGIN' : 'WELCOME BACK' }}</p>
        </div>

        <div class="gx-login__card">
          <!-- 微信扫码 -->
          <div v-if="wxMode" class="gx-login__wx">
            <div class="gx-login__wx-code">
              <img v-if="wxCode" :src="wxCode" alt="微信扫码登录" />
              <div v-else class="gx-login__wx-loading">二维码加载中...</div>
            </div>
            <p class="gx-login__wx-tip">打开手机微信，扫描二维码登录</p>
          </div>

          <!-- 账号密码 / 短信 -->
          <form v-else @submit.prevent="submit">
            <template v-if="mode === 'pwd'">
              <div class="gx-input">
                <label class="gx-input__label">手机号</label>
                <input
                  :value="account"
                  type="tel"
                  inputmode="numeric"
                  maxlength="11"
                  class="gx-input__field"
                  :class="{ 'gx-input__field--foc': focusField === 'account' }"
                  placeholder="请输入手机号"
                  @focus="focusField = 'account'"
                  @input="sanitizeMobileInput"
                  @blur="focusField = ''"
                />
              </div>
            </template>

            <template v-if="mode === 'pwd'">
              <div class="gx-input">
                <label class="gx-input__label">密码</label>
                <div class="gx-input__wrap">
                  <input
                    v-model="password"
                    :type="showPwd ? 'text' : 'password'"
                    class="gx-input__field"
                    :class="{ 'gx-input__field--foc': focusField === 'pwd' }"
                    placeholder="请输入密码"
                    @focus="focusField = 'pwd'"
                    @blur="focusField = ''"
                  />
                  <button type="button" class="gx-input__eye" @click="showPwd = !showPwd">{{ showPwd ? '🙈' : '👁️' }}</button>
                </div>
              </div>
              <label class="gx-login__remember">
                <input v-model="rememberPassword" type="checkbox" class="gx-login__remember-check" />
                <span class="gx-login__remember-mark" aria-hidden="true">✓</span>
                <span>记住密码</span>
              </label>
            </template>

            <template v-else>
              <div class="gx-input">
                <label class="gx-input__label">手机号</label>
                <input
                  :value="account"
                  type="tel"
                  inputmode="numeric"
                  maxlength="11"
                  class="gx-input__field"
                  :class="{ 'gx-input__field--foc': focusField === 'sms' }"
                  placeholder="请输入手机号"
                  @focus="focusField = 'sms'"
                  @input="sanitizeMobileInput"
                  @blur="focusField = ''"
                />
              </div>
              <div class="gx-reg__code">
                <div class="gx-input">
                  <label class="gx-input__label">验证码</label>
                  <input
                      v-model="smsCode"
                      class="gx-input__field"
                      :class="{ 'gx-input__field--foc': focusField === 'code' }"
                      placeholder="请输入验证码"
                      @focus="focusField = 'code'"
                      @blur="focusField = ''"
                    />
                </div>
                <button type="button" class="gx-input__code" :disabled="codeCountdown > 0" @click="sendCode">
                  {{ codeCountdown > 0 ? codeCountdown + 's' : '获取验证码' }}
                </button>
              </div>
            </template>

            <button type="submit" class="gx-login__submit" :disabled="loading">
              {{ loading ? '登录中...' : '登录' }}
            </button>

            <div class="gx-login__or">
              <span class="gx-login__or-line"></span>
              <span class="gx-login__or-text">或使用其他方式登录</span>
              <span class="gx-login__or-line"></span>
            </div>
            <div class="gx-login__others">
              <button type="button" class="gx-login__other" @click="mode = mode === 'pwd' ? 'sms' : 'pwd'">
                <span aria-hidden="true">{{ mode === 'pwd' ? '📱' : '🔒' }}</span>
                {{ mode === 'pwd' ? '短信登录' : '密码登录' }}
              </button>
            </div>
          </form>
        </div>

        <p class="gx-login__register">
          还没账户？
          <a @click="$router.replace('/register')">立即注册</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import common from '../../assets/js/utils/common'
import StarsCanvas from '../../components/newUi/StarsCanvas.vue'
import FloatPts from '../../components/newUi/FloatPts.vue'

export default {
  name: 'NewLoginPage',
  components: { StarsCanvas, FloatPts },
  data() {
    return {
      stats: [
        { v: '10,000+', l: '星人用户' },
        { v: '1亿+', l: '服务GMV' },
        { v: '99.99%', l: '检测准确' }
      ],
      mode: 'pwd', // pwd | sms
      wxMode: false,
      account: '',
      password: '',
      rememberPassword: false,
      smsCode: '',
      showPwd: false,
      focusField: '',
      loading: false,
      codeCountdown: 0,
      wxCode: '',
      intUid: '',
      checkTimer: null
    }
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.login.token
    }
  },
  watch: {
    rememberPassword() {
      this.syncRememberedPassword()
    },
    account() {
      this.syncRememberedPassword()
    },
    password() {
      this.syncRememberedPassword()
    }
  },
  mounted() {
    this.restoreRememberedPassword()
  },
  beforeDestroy() {
    if (this.checkTimer) clearTimeout(this.checkTimer)
  },
  methods: {
    ...mapActions({
      DoAccountLogin: 'login/DoAccountLogin',
      DoCodeLogin: 'login/DoCodeLogin',
      getCodeData: 'login/getCodeData',
      getQrcodeData: 'login/getQrcodeData',
      checkWxBind: 'login/checkWxBind',
      getUserinfoData: 'login/getUserinfoData'
    }),
    goBack() {
      this.$router.push('/')
    },
    sanitizeMobileInput(event) {
      const mobile = event.target.value.replace(/\D/g, '').slice(0, 11)
      event.target.value = mobile
      this.account = mobile
    },
    restoreRememberedPassword() {
      const businessLoginData = this.$cookies.get('businessLoginData')
      if (
        !businessLoginData ||
        typeof businessLoginData !== 'object' ||
        businessLoginData.remember_pwd !== true ||
        typeof businessLoginData.login_phone !== 'string' ||
        typeof businessLoginData.login_pwd !== 'string'
      ) {
        return
      }

      this.rememberPassword = true
      this.account = businessLoginData.login_phone
      this.password = businessLoginData.login_pwd
    },
    syncRememberedPassword() {
      if (!this.rememberPassword) {
        this.$cookies.remove('businessLoginData')
        return
      }

      if (!this.account || !this.password) {
        return
      }

      this.$cookies.set('businessLoginData', {
        remember_pwd: true,
        login_phone: this.account,
        login_pwd: this.password
      }, '30d')
    },
    afterLogin() {
      return this.getUserinfoData({
        data: {},
        success: (res) => {
          this.loading = false
          if (res.code !== 200) {
            this.$message({ message: res.message || '获取用户权限失败', type: 'error' })
            return
          }
          this.$message({ message: '登录成功', type: 'success' })
          this.$router.replace('/ucenter').catch(() => {})
        }
      }).catch(() => {
        this.loading = false
        this.$message({ message: '获取用户权限失败，请重试', type: 'error' })
      })
    },
    submit() {
      if (!this.account) {
        this.$message({ message: '请输入手机号', type: 'error' })
        return
      }
      if (this.mode === 'pwd') {
        if (!this.password) {
          this.$message({ message: '请输入密码', type: 'error' })
          return
        }
        if (this.loading) return
        this.loading = true
        this.DoAccountLogin({
          data: { mobile: this.account, password: this.password },
          success: (res) => {
            if (res.code === 200) {
              this.syncRememberedPassword()
              this.afterLogin()
            } else {
              this.loading = false
              this.$message({ message: res.message, type: 'error' })
            }
          }
        })
      } else {
        if (!common._verify_mobile(this.account)) {
          this.$message({ message: '请输入正确手机号', type: 'error' })
          return
        }
        if (!this.smsCode) {
          this.$message({ message: '请获取短信验证码', type: 'error' })
          return
        }
        if (this.loading) return
        this.loading = true
        this.DoCodeLogin({
          data: { mobile: this.account, sms_code: this.smsCode },
          success: (res) => {
            if (res.code === 200) {
              this.afterLogin()
            } else {
              this.loading = false
              this.$message({ message: res.message, type: 'error' })
            }
          }
        })
      }
    },
    sendCode() {
      if (!common._verify_mobile(this.account)) {
        this.$message({ message: '请输入正确手机号', type: 'error' })
        return
      }
      this.getCodeData({
        data: { mobile: this.account },
        success: (res) => {
          if (res.code === 200) {
            this.$message({ message: '发送成功~', type: 'success' })
            this.codeCountdown = 60
            const timer = setInterval(() => {
              this.codeCountdown -= 1
              if (this.codeCountdown <= 0) clearInterval(timer)
            }, 1000)
          } else {
            this.$message({ message: res.message, type: 'error' })
          }
        }
      })
    },
    startWx() {
      this.wxMode = true
      this.getQrcodeData({
        data: { mobile: '', level: '2', bind_uid: '0', type: '1' },
        success: (res) => {
          if (res.code === 200) {
            this.wxCode = res.message.ticket_img
            this.intUid = res.message.int_uid
            this.checkBind()
          } else {
            this.$message({ message: res.message, type: 'error' })
            this.wxMode = false
          }
        }
      })
    },
    checkBind() {
      this.checkWxBind({
        data: { int_uid: this.intUid },
        success: (res) => {
          if (res.code === 200) {
            this.$message({ message: res.message, type: 'success' })
            this.wxMode = false
            this.afterLogin()
          } else {
            this.checkTimer = setTimeout(() => this.checkBind(), 1500)
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.gx-login {
  height: 100vh;
  display: flex;
  overflow: hidden;
  background: linear-gradient(135deg, #1A2855 0%, #243470 55%, #1A2855 100%);
  position: relative;
  font-family: 'Noto Sans SC', sans-serif;
}
.gx-login__orb {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
  animation: gx-orbFloat 10s ease-in-out infinite;
}
.gx-login__orb--1 {
  left: 32%;
  top: 32%;
  width: 400px;
  height: 400px;
  transform: translate(-50%, -50%);
  background: radial-gradient(circle, rgba(212, 169, 70, .22) 0%, transparent 68%);
}
.gx-login__orb--2 {
  left: 74%;
  top: 70%;
  width: 250px;
  height: 250px;
  transform: translate(-50%, -50%);
  background: radial-gradient(circle, rgba(63, 182, 224, .14) 0%, transparent 68%);
}
.gx-login__back {
  position: absolute;
  top: 24px;
  left: 28px;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 6px;
  background: rgba(255, 255, 255, .07);
  border: 1px solid rgba(255, 255, 255, .12);
  border-radius: 9px;
  padding: 8px 16px;
  cursor: pointer;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 13px;
  color: #C8C0E0;
  transition: all 0.4s cubic-bezier(.4, 0, .2, 1);
}
.gx-login__back:hover {
  color: #D4A946;
  border-color: rgba(212, 169, 70, .45);
}
.gx-login__left {
  width: 55%;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  padding: 0 52px;
  text-align: center;
}
.gx-login__tree {
  font-size: 96px;
  margin-bottom: 22px;
  display: inline-block;
  animation: gx-treeBreathe 3s ease-in-out infinite;
}
.gx-login__name {
  font-family: 'Noto Serif SC', serif;
  font-size: 38px;
  font-weight: 700;
  margin-bottom: 12px;
  background: linear-gradient(135deg, #D4A946, #E8B950);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: gx-goldGlow 4s ease-in-out infinite;
}
.gx-login__slogan {
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 16px;
  color: #FFFFFF;
  margin-bottom: 6px;
  font-weight: 500;
}
.gx-login__sub {
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 14px;
  color: #C8C0E0;
}
.gx-login__divider {
  width: 56px;
  height: 1.5px;
  background: linear-gradient(90deg, transparent, #D4A946, transparent);
  margin: 26px auto;
}
.gx-login__stats {
  display: flex;
  gap: 38px;
}
.gx-login__stat-v {
  font-family: Inter, monospace;
  font-size: 20px;
  font-weight: 700;
  color: #D4A946;
  margin-bottom: 3px;
}
.gx-login__stat-l {
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 12px;
  color: #C8C0E0;
}
.gx-login__right {
  width: 45%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, rgba(26, 40, 85, .6) 0%, rgba(15, 27, 61, .8) 100%);
  overflow-y: auto;
  padding: 24px 0;
}
.gx-login__panel {
  width: 100%;
  max-width: 400px;
  padding: 0 44px;
  animation: gx-cardIn 0.5s ease-out both;
  box-sizing: border-box;
}
.gx-login__head {
  text-align: center;
  margin-bottom: 28px;
}
.gx-login__head-icon {
  font-size: 38px;
  margin-bottom: 8px;
  display: inline-block;
  animation: gx-treeBreathe 3s ease-in-out infinite;
}
.gx-login__title {
  font-family: 'Noto Serif SC', serif;
  font-size: 26px;
  font-weight: 700;
  color: #FFFFFF;
  margin: 0 0 5px;
  animation: gx-goldGlow 4s ease-in-out infinite;
}
.gx-login__en {
  font-family: Inter, monospace;
  font-size: 11px;
  color: #00D4FF;
  letter-spacing: 3px;
  margin: 0;
}
.gx-login__card {
  border-radius: 20px;
  background: rgba(255, 255, 255, .08);
  backdrop-filter: blur(22px);
  -webkit-backdrop-filter: blur(22px);
  border: 1.5px solid rgba(212, 169, 70, .28);
  box-shadow: 0 8px 40px rgba(0, 0, 0, .45), inset 0 1px rgba(255, 255, 255, .08);
  padding: 28px 26px;
  position: relative;
  overflow: hidden;
}
.gx-login__card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 15%;
  right: 15%;
  height: 1.5px;
  background: linear-gradient(90deg, transparent, #D4A946, transparent);
}
.gx-input {
  margin-bottom: 16px;
}
.gx-input__label {
  display: block;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 13px;
  color: #C8C0E0;
  margin-bottom: 7px;
  transition: color 0.4s cubic-bezier(.4, 0, .2, 1);
}
.gx-input__wrap {
  position: relative;
}
.gx-input__field {
  width: 100%;
  height: 50px;
  padding: 0 16px;
  border-radius: 11px;
  background: rgba(255, 255, 255, .08);
  border: 1.5px solid rgba(212, 169, 70, .22);
  box-shadow: inset 0 1px rgba(255, 255, 255, .05);
  color: #FFFFFF;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 14px;
  outline: none;
  box-sizing: border-box;
  transition: all 0.4s cubic-bezier(.4, 0, .2, 1);
}
.gx-input__field--foc {
  background: rgba(212, 169, 70, .06);
  border-color: rgba(212, 169, 70, .7);
  box-shadow: 0 0 0 3px rgba(212, 169, 70, .14), inset 0 1px rgba(255, 255, 255, .07);
}
.gx-input__eye {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  color: #C8C0E0;
  font-size: 16px;
  line-height: 1;
  padding: 0;
  transition: color 0.4s cubic-bezier(.4, 0, .2, 1);
}
.gx-input__eye:hover {
  color: #D4A946;
}
.gx-input__code {
  height: 50px;
  margin-top: 27px;
  padding: 0 14px;
  border-radius: 11px;
  flex-shrink: 0;
  border: 1px solid rgba(212, 169, 70, 0.4);
  background: rgba(212, 169, 70, 0.1);
  cursor: pointer;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 12px;
  color: rgb(212, 169, 70);
  white-space: nowrap;
  transition: 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}
.gx-input__code:disabled {
  opacity: .5;
  cursor: not-allowed;
}
.gx-login__remember {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin: -4px 0 18px;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 13px;
  color: #C8C0E0;
  cursor: pointer;
}
.gx-login__remember-check {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: 0;
  opacity: 0;
}
.gx-login__remember-mark {
  width: 15px;
  height: 15px;
  border: 1px solid rgba(212, 169, 70, .45);
  border-radius: 4px;
  box-sizing: border-box;
  color: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  transition: all 0.2s ease;
}
.gx-login__remember-check:checked + .gx-login__remember-mark {
  background: #D4A946;
  border-color: #D4A946;
  color: #1A1A2E;
}
.gx-login__remember-check:focus-visible + .gx-login__remember-mark {
  box-shadow: 0 0 0 3px rgba(212, 169, 70, .24);
}
.gx-login__remember-check + .gx-login__remember-mark {
  cursor: pointer;
}
.gx-login__submit {
  width: 100%;
  height: 50px;
  border-radius: 12px;
  cursor: pointer;
  background: linear-gradient(135deg, #D4A946, #E8B950);
  border: none;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #1A1A2E;
  box-shadow: 0 6px 22px rgba(212, 169, 70, .45);
  transition: all 0.4s cubic-bezier(.4, 0, .2, 1);
}
.gx-login__submit:hover {
  transform: scale(1.05);
  box-shadow: 0 10px 32px rgba(212, 169, 70, .65);
}
.gx-login__submit:disabled {
  background: rgba(212, 169, 70, .35);
  box-shadow: none;
  cursor: not-allowed;
  transform: none;
}
.gx-login__or {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 22px 0;
}
.gx-login__or-line {
  flex: 1;
  height: 1px;
  background: rgba(255, 255, 255, .1);
}
.gx-login__or-text {
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 12px;
  color: #C8C0E0;
}
.gx-login__others {
  display: flex;
  gap: 10px;
}
.gx-login__other {
  width: 100%;
  flex: 1;
  height: 46px;
  border-radius: 11px;
  border: 1.5px solid rgba(212, 169, 70, .22);
  background: rgba(255, 255, 255, .06);
  cursor: pointer;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 13px;
  color: #C8C0E0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: all 0.4s cubic-bezier(.4, 0, .2, 1);
}
.gx-login__other:hover {
  border-color: rgba(212, 169, 70, .6);
  background: rgba(212, 169, 70, .08);
  color: #D4A946;
  box-shadow: 0 4px 16px rgba(212, 169, 70, .18);
}
.gx-login__register {
  text-align: center;
  margin-top: 20px;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 13px;
  color: #C8C0E0;
}
.gx-login__register a {
  color: #D4A946;
  cursor: pointer;
}
.gx-login__wx-code {
  width: 200px;
  height: 200px;
  margin: 10px auto 16px;
  border-radius: 12px;
  background: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.gx-login__wx-code img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.gx-login__wx-loading {
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 12px;
  color: #888;
}
.gx-login__wx-tip {
  text-align: center;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 13px;
  color: #C8C0E0;
}
.gx-reg__code{
  display: flex;
  gap: 10px;
}
@media (max-width: 900px) {
  .gx-login__left {
    display: none;
  }
  .gx-login__right {
    width: 100%;
  }
}
</style>
